<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.texts.clients.title') }}
    </h1>
    <h2 class="primary--text">
      {{ $t('documentation.texts.clients.edit.title') }}
    </h2>
    <p>
      {{ $t('documentation.texts.clients.edit.paragraph1') }}
    </p>
    <p>
      {{ $t('documentation.texts.clients.edit.paragraph2') }}
    </p>
    <v-img style="width: 100%; max-width: 900px; contain" :src="pic1Name" />
    <p>
      {{ $t('documentation.texts.clients.edit.paragraph3') }}
    </p>
    <v-img style="width: 100%; max-width: 800px" contain :src="pic2Name" />
  </v-col>
</template>

<script>
export default {
  computed: {
    pic1Name() {
      return require('@/assets/documentation/clients/' +
        this.$t('documentation.texts.clients.edit.pic1') +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/clients/' +
        this.$t('documentation.texts.clients.edit.pic2') +
        '.png')
    },
  },
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
